import { useNavigate } from "react-router-dom";
import { customAuthAxios } from "../../utils/customAuthAxios";
import { useSuccessToast } from "../toast/useSuccessToast";

export const useRegisterKuchikomyuSetting = (restaurantId?: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();

  const onSubmit = async (data: any) => {
    if (!restaurantId) {
      return;
    }

    // ✅ restaurant_id を POST データに追加
    data.restaurant_id = restaurantId;

    // ✅ unique_question が null/undefined のときは 0 を代入
    if (data.unique_question === null || data.unique_question === undefined) {
      data.unique_question = 0;
    }

    try {
      await customAuthAxios.post(`/kuchikomyu/settings/`, data);
      showToast('登録が完了しました');
      navigate(-1);
    } catch (error: any) {
      console.error("登録エラー:", error.response?.data || error.message);
    }
  };

  return onSubmit;
};